import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { News } from '../../../../shared/interface';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-modifica-news-backoffice',
  templateUrl: './modifica-news-backoffice.component.html',
  styleUrl: './modifica-news-backoffice.component.css'
})
export class ModificaNewsBackofficeComponent {

  @ViewChild("confirmDeletePopupRef") confirmPopup!: ConfirmPopup;

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private datePipe: DatePipe, private confirmationService: ConfirmationService) { }

  formNews!: FormGroup;

  notizia?: News;

  show_image: boolean = false;

  ngOnInit(): void {

    this.formNews = new FormGroup({
      titolo: new FormControl(null, Validators.required),
      data: new FormControl(null, Validators.required),
      descrizione: new FormControl(null),
      evidenzia: new FormControl(null),
      link: new FormControl(null),
      link_url: new FormControl(null)
    })

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getNotizia(id).subscribe({
        next: (data) => this.notizia = data,
        error: (err) => this.router.navigate(['/backoffice/news']),
        complete: () => {

          this.formNews.patchValue({
            titolo: this.notizia?.titolo,
            descrizione: this.notizia?.descrizione,
            data: new Date(this.notizia!.data_creazione),
            evidenzia: this.notizia?.evidenzia ? ['evidenzia'] : [],
            link: this.notizia?.link ? ['link'] : [],
            link_url: this.notizia?.link_url
          })

        }
      })

    })
  }

  onDeleteNewsPopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare la news?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteNotizia(this.notizia!.id).subscribe({
          next: (data) => this.apiService.setNotizie(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/news']);
            this.apiService.message("success", "Eliminazione", "La news è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onLink(value: any) {
    if (value.length > 0) {
      this.formNews.get('link')?.setValidators(Validators.required);
    } else {
      this.formNews.get('link')?.clearValidators();
    }

    this.formNews.get('link')?.updateValueAndValidity();

  }

  onSubmit() {

    let news = {
      titolo: this.formNews.get('titolo')?.value,
      data: this.datePipe.transform(this.formNews.get('data')?.value, 'yyyy-MM-dd') || '',
      descrizione: this.formNews.get('descrizione')?.value || '',
      evidenzia: this.formNews.get('evidenzia')?.value ? (this.formNews.get('evidenzia')?.value.length > 0 ? true : false) : false,
      link: this.formNews.get('link')?.value ? (this.formNews.get('link')?.value.length > 0 ? true : false) : false,
      link_url: this.formNews.get('link_url')?.value || ''
    }

    this.apiService.updateNotizia(news, this.notizia!.id).subscribe({
      next: (data) => this.apiService.setNotizie(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/news'])
        this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
      }
    })

  }

}
